<script>
import { isNil } from "lodash";
import { toCurrency } from "@/helpers/toCurrency";

export default {
  props: {
    value: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      innerValue: this.value,
      isEditing: false,
      rawInput: ""
    };
  },
  computed: {
    displayValue() {
      if (this.isEditing) {
        return this.rawInput;
      }

      if (isNil(this.innerValue)) {
        return "";
      }

      return this.formatNumberWithSeparators(this.innerValue);
    }
  },
  watch: {
    value(nextValue) {
      if (isNil(nextValue) || isNaN(nextValue)) {
        this.innerValue = null;

        if (!this.isEditing) {
          this.rawInput = "";
        }

        return;
      }

      this.innerValue = Math.abs(nextValue);

      if (!this.isEditing) {
        this.rawInput = "";
      }
    }
  },
  methods: {
    formatNumberWithSeparators(value) {
      const absValue = Math.abs(value);
      return toCurrency(absValue)
        .replace("R$", "")
        .trim();
    },
    onBlur() {
      this.isEditing = false;
      this.rawInput = "";
    },
    onFocus() {
      this.isEditing = true;

      if (!isNil(this.innerValue)) {
        this.rawInput = this.formatNumberWithSeparators(this.innerValue);
      } else {
        this.rawInput = "";
      }
    },
    updateValue(inputValue) {
      this.rawInput = inputValue;
      let cleanedValue = inputValue;

      cleanedValue = cleanedValue.replace(/-/g, "");
      const lastCommaIndex = cleanedValue.lastIndexOf(",");
      let integerPart = "";
      let decimalPart = "";

      if (lastCommaIndex !== -1) {
        integerPart = cleanedValue.substring(0, lastCommaIndex);
        decimalPart = cleanedValue.substring(lastCommaIndex + 1);
        integerPart = integerPart.replace(/\./g, "");
        decimalPart = decimalPart.replace(/[^0-9]/g, "").substring(0, 2);
      } else {
        integerPart = cleanedValue.replace(/[^0-9]/g, "");
        decimalPart = "";
      }

      integerPart = integerPart.replace(/[^0-9]/g, "");
      let numericStr = integerPart;

      if (decimalPart !== "") {
        numericStr += "." + decimalPart;
      }

      if (numericStr.replace(/[^0-9]/g, "") === "") {
        this.innerValue = null;
        this.$emit("input", null);
        return;
      }

      let numericValue = parseFloat(numericStr);

      if (isNaN(numericValue)) {
        return;
      }

      this.innerValue = numericValue;
      this.$emit("input", numericValue);
    }
  }
};
</script>

<template>
  <v-text-field
    v-bind="$attrs"
    dense
    outlined
    :value="displayValue"
    @blur="onBlur"
    @focus="onFocus"
    @input="updateValue"
  ></v-text-field>
</template>
